import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { BaseTableService } from '@shared/base/base-table-service.service';
import { IListRetailer } from '@models/retailer.model';
import { TableColumn } from '@shared/interface/table.interface';
import { BaseDatasource } from '@shared/base/base.datasource';
import { BehaviorSubject, Subscription } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { PageInfoService, PageLink } from '@metronic/layout';
import { UtilitiesService } from '@services/utilities.service';
import { RolePrivilegeService } from '@services/role-privilege.service';
import { API } from '@config/constants/api.constant';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { FilterService } from '@services/filter.service';
import { RetailerService } from '../../retailer.service';
import { IDataRetailerList } from '../../retailers.interface';

@Component({
  selector: 'app-pending-submission',
  templateUrl: './pending-submission.component.html',
  styleUrls: ['./pending-submission.component.scss'],
})
export class PendingSubmissionComponent implements OnInit, OnDestroy {
  @ViewChild(MatSort, { static: false }) matSort: MatSort;
  @Output() totalCount = new EventEmitter();

  STRING_CONSTANTS = STRING_CONSTANTS;
  iconNone = STRING_CONSTANTS.ICON.IC_RETAIL_NONE;
  isLoading = false;
  // table
  baseTable: BaseTableService<IListRetailer> = this.base;
  tableColumns: TableColumn[];
  displayedColumns: string[];
  baseDatasourcePending: BaseDatasource<IListRetailer>;
  string_filter?: string;
  checkActive: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isOpenFilter: boolean = false;
  isActiveFilter: boolean = false;
  filterForm: FormGroup;
  privilageDetailPending: boolean;

  dataList: IDataRetailerList;
  links: Array<PageLink> = [
    {
      title: 'Retailer',
      path: '',
      isActive: false,
    },
    {
      title: '',
      path: '',
      isActive: false,
      isSeparator: true,
    },
    {
      title: 'Sedang Menunggu',
      path: '',
      isActive: true,
    },
  ];

  public static totalCount = new BehaviorSubject(0);
  private unsubscribe: Subscription[] = [];

  constructor(
    private pageInfoService: PageInfoService,
    private base: BaseTableService<IListRetailer>,
    public utilities: UtilitiesService,
    public filterService: FilterService,
    private rolePrivilegeService: RolePrivilegeService,
    private retailerService: RetailerService
  ) {}

  ngOnInit() {
    this.pageInfoService.updateTitle(`Retailer Pending`);
    this.privilageDetailPending = this.rolePrivilegeService.checkPrivilege('RETAILER', 'LIST_RETAILER_MENUNGGU', 'TAB_LIST_SUBMISSION', 'CTA_VIEW_DETAIL');
    this.pageInfoService.updateBreadcrumbs(this.links);
    this.setTableData();
    this.dataList = {
      status: 'pending',
      tab: 'submission',
      view: 'edit-request',
    };
  }

  setTableData() {
    this.tableColumns = this.retailerService.getPendingSubmissionTableColumns();
    this.tableColumns = this.utilities.privilegeTableColumns(this.privilageDetailPending, this.tableColumns);
  }

  onTotalCount = (e: number) => PendingSubmissionComponent.totalCount.next(e);

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  protected readonly API = API;
}
